<script>
    export default {
        methods: {
            getTransformedEnumAttributes({ enumAttributes = [], numericAttributes = [] }) {
                const uniqueParentAttributes = this.getUniqueParentAttributes(enumAttributes);

                const attributes = enumAttributes.reduce((result, item) => {

                    const value = this.getCombinedValue(item, numericAttributes);

                    const subItem = {
                        value,
                        system_name: item.value_system_name,
                        parent_id: item.parent_id,
                    }

                    if (!result[item.system_name]) {
                        const { attribute_id, product_id, system_name, value_id } = item;
                        const name = item.is_pestitsidy
                            ? this.$t('customAttributesNames')[item.system_name] || item.name
                            : item.name;
                        result[item.system_name] = {
                            attribute_id, product_id, name, system_name, value_id,
                            items: {
                                values: [subItem].sort(function(a, b) {
                                    if (a.value > b.value) {
                                        return 1;
                                    }
                                    if (a.value < b.value) {
                                        return -1;
                                    }
                                    return 0;
                                }),
                                parents: uniqueParentAttributes.filter(attr => subItem.parent_id === attr.value_id),
                            },
                        };
                    } else {
                        result[item.system_name].items.values.push(subItem);
                        result[item.system_name].items.parents = uniqueParentAttributes.filter(attr =>
                            result[item.system_name].items.values.some(value => value.parent_id === attr.value_id),
                        );
                    }
                    result[item.system_name].has_numeric_attributes = !!numericAttributes.find(val => val.enum_id === item.attribute_id);

                    return result;
                }, {});
                let result = {};
                for (const [key, value] of Object.entries(attributes)) {
                    result[key] = {
                        attribute_id: value.attribute_id,
                        has_numeric_attributes: value.has_numeric_attributes,
                        items: {
                            parents: value.items.parents.sort(function(a, b) {
                                if (a.value.toLowerCase() > b.value.toLowerCase()) {
                                    return 1;
                                }
                                if (a.value.toLowerCase() < b.value.toLowerCase()) {
                                    return -1;
                                }
                                return 0;
                            }),
                            values: !value.has_numeric_attributes ? value.items.values.sort(function(a, b) {
                                if (a.value.toLowerCase() > b.value.toLowerCase()) {
                                    return 1;
                                }
                                if (a.value.toLowerCase() < b.value.toLowerCase()) {
                                    return -1;
                                }
                                return 0;
                            }) : value.items.values.sort(function(a, b) {
                                if (a.value.name.toLowerCase() > b.value.name.toLowerCase()) {
                                    return 1;
                                }
                                if (a.value.name.toLowerCase() < b.value.name.toLowerCase()) {
                                    return -1;
                                }
                                return 0;
                            }),
                        },
                        name: value.name,
                        product_id: value.product_id,
                        system_name: value.system_name,
                    }
                }

                return result;
            },
            getUniqueParentAttributes(enumAttributes) {
                const uniqueIds = [...new Set(enumAttributes.map(attr => attr.parent_id).filter(Boolean))];

                return enumAttributes.filter(attr => uniqueIds.includes(attr.value_id));
            },
            getCombinedValue(enumData, numericAttributes) {
                const numericData = numericAttributes.find(item => item.value_id === enumData.value_id);


                if (!numericData) {
                    const emptyNum = numericAttributes.find(item => item.enum_id === enumData.attribute_id)
                    if(emptyNum) {
                        return {
                            system_name: enumData.value_system_name,
                            name: enumData.value,
                            numeric: '-'
                        }
                    }
                    return enumData.value;
                }
                return {
                    system_name: enumData.value_system_name,
                    name: enumData.value,
                    numeric: numericData.is_range
                        ? `(${numericData.min_value} - ${numericData.max_value} ${numericData.unit_name})`
                        : `(${numericData.value} ${numericData.unit_name})`
                };
            },
        },
    }
</script>
